<script>
   import Modal from './modal.svelte'
   export let content
</script>

<Modal id={'careers'}>
   <div class="popup-careers-content">
      {#if content.text}
         {@html content.text}
      {:else}
         <h2>Ready to Get Started?</h2>
         <p>Let's make sure you get to the right place! Please tell us a bit more about yourself.</p>
      {/if}
      {#if content.btns}
      <div class="btns-wrap d-sm-flex flex-column flex-md-row align-items-center" style="margin-top: 1rem;">
         {#each content.btns as btn} 
            <a href={btn['btn'].url} target={btn['btn'].target ? btn['btn'].target : '_self'} class="btn" style="white-space:normal;">
               {btn['btn'].title}
            </a>
         {/each}
      </div>
      {/if}
   </div>
</Modal> 